module.exports = __webpack_public_path__ + "media/images/lb/470-26759b4c4e56e7aed36dfc31a03baa88.svg";